import {
  GET_LABTEST_FAIL,
  GET_LABTEST_SUCCESS,
  GET_LABTESTS_FAIL,
  GET_LABTESTS_SUCCESS,
  ADD_LABTEST_SUCCESS,
  ADD_LABTEST_FAIL,
  UPDATE_LABTEST_SUCCESS,
  UPDATE_LABTEST_FAIL,
  DELETE_LABTEST_SUCCESS,
  DELETE_LABTEST_FAIL,  
  SET_STATE_LABTEST,
  GET_LABTESTSSAMPLES_SUCCESS,
  GET_LABTESTSSAMPLES_FAIL
} from "./actionTypes";

const INIT_STATE = {
  labTests: [],
  labTest: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labTests = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_STATE_LABTEST:
      return { ...state, loading: action.payload }

    case GET_LABTESTS_SUCCESS:
      return {
        ...state,
        labTests: action.payload.labTests,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case GET_LABTESTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    
    case GET_LABTESTSSAMPLES_SUCCESS:
      return {
        ...state,
        labTests: labTests.map( labTests => 
          labTests.id.toString() === action.payload.id.toString() ??
          labTests.details.push(action.payload.labTestsSamples))
      };

    case GET_LABTESTSSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABTEST_SUCCESS:
      return {
        ...state,
        labTests: [...state.labTests, action.payload],
      };

    case ADD_LABTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABTEST_SUCCESS:
      return {
        ...state,
        labTests: state.labTests.map(labTest =>
          labTest.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labTest }
            : labTest
        ),
      };

    case UPDATE_LABTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABTEST_SUCCESS:
      return {
        ...state,
        labTests: state.labTests.filter(
          labTest => labTest.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABTEST_SUCCESS:
      return {
        ...state,
        labTest: action.payload,
      };

    case GET_LABTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labTests;
